// AI critique usage tracking + unlock token utilities (browser-side soft cap)
import { secureGet, secureGetJSON, secureSet, secureRemove } from "@/lib/secureStorage";

const USAGE_KEY = "centennial_ai_usage_v1";
const TOKEN_KEY = "centennial_unlock_token_v1";
export const DAILY_CAP = 3;

const todayKey = () => {
  const d = new Date();
  return `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}`;
};

export const getUsage = () => {
  const obj = secureGetJSON(USAGE_KEY, null);
  if (!obj || obj.day !== todayKey()) return { day: todayKey(), count: 0 };
  return obj;
};

export const incrementUsage = () => {
  const u = getUsage();
  const next = { day: todayKey(), count: u.count + 1 };
  secureSet(USAGE_KEY, next);
  return next;
};

export const setUnlockToken = (token) => {
  if (token) secureSet(TOKEN_KEY, token);
};

export const getUnlockToken = () => {
  return secureGet(TOKEN_KEY);
};

export const clearUnlockToken = () => {
  secureRemove(TOKEN_KEY);
};

export const canCritique = (hasValidToken) => {
  if (hasValidToken) return true;
  const u = getUsage();
  return u.count < DAILY_CAP;
};

export const remainingFreeCritiques = (hasValidToken) => {
  if (hasValidToken) return Infinity;
  return Math.max(0, DAILY_CAP - getUsage().count);
};
